<template>
    <div class="mx-auto col-lg-5 col-md-8 col-sm-12 header-margin">
        <div class="text-center">
            <div>
                <img class="success_email_img p-4" src="./images/success_contact.png">
            </div>

            <div class="show-check-email-message" v-if="$route.path === '/registration/check-email'">
                <h5 class="text-black-50" v-html="$t('auth.checkEmail')">
                </h5>
            </div>
            <div class="show-check-email-message" v-else>
                <h5 class="text-black-50" v-html="$t('auth.forgotPasswordEmail')">
                </h5>
            </div>

            <div class="pt-5">
                <router-link to="/" class="btn btn-primary pr-5 pl-5">{{ $t('auth.closeBtn') }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'check-email-module',

        components: {},

        mounted() {
        },

        data() {
            return {
            }
        },

        methods: {
        }
    }
</script>

<style scoped>
    .success_email_img {
        max-width: 150px;
        width: 100%;
    }
    .show-check-email-message >>> br {
            display: inline;
    }
    @media screen and (max-width: 767px) {
        .show-check-email-message {
            text-align: left;
        }
        .show-check-email-message >>> br {
            display: none;
        }
    }
</style>
